export const HOME = '/';
export const TOPIC = '/topic/:topicID'
export const ADMIN = '/admin'
export const ADMIN_AUTH = '/admin/auth'